module.exports = __webpack_public_path__ + "img/qb2.12de295b.png";